// custom kendo button

// kendoButton.js

import React, { useState } from "react";
import "../styles.css";
import { Button } from "@progress/kendo-react-buttons";
import CircularProgress from "@mui/material/CircularProgress";

// Usage of the Kendo Button component
const KendoButton = ({ label = "Button", loading, onClick, icon, disabled, ...otherProps }) => {
  const styles = {
    labelStyles: {
      marginTop: "3px",
      marginRight: "5px",
    },
    buttonStyles: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
    },
    loaderStyles: {
      // position: "absolute",
      // left: "35%",
      // top: "20%",
      transform: "translate(-50%, -50%)",
      marginRight: "5px",
    },
    iconStyle:{
      marginLeft: "5px",
      fontSize: "16px",
      height: "20px",
    }
  }
  return (
    <div>
      <Button
        className="k-button kc-button"
        onClick={onClick}
        {...otherProps}
        disabled={loading || disabled}
        style={styles.buttonStyles}
      >
        {loading && (
          <CircularProgress
            size={20}
            color="inherit"
            style={styles.loaderStyles}
          />
        )}
        <span style={styles.buttonStyles}>{label}</span>
        {icon && <span style={styles.iconStyle}>{icon}</span>}
      </Button>
    </div>
  );
};

export default KendoButton;
